import { eq } from "drizzle-orm";
import { salesOrders, salesOrderLines } from "@briolin/db";
import type { TestDb } from "@briolin/db/src/testing.js";
import { postDocument, unpostDocument, type DocumentMovements } from "../posting.js";

type Db = TestDb;
type OrderLine = { productId: string; warehouseId: string; qty: number };

export function buildOrderReserveMovements(input: { lines: OrderLine[] }): DocumentMovements {
  return {
    stock: input.lines.map((l) => ({ productId: l.productId, warehouseId: l.warehouseId, qtyDelta: l.qty, kind: "reserve" as const })),
  };
}

export async function postOrderReserve(db: Db, orderId: string): Promise<void> {
  const [order] = await db.select().from(salesOrders).where(eq(salesOrders.id, orderId));
  if (!order) throw new Error(`SALES_ORDER_NOT_FOUND: ${orderId}`);
  const lines = await db.select().from(salesOrderLines).where(eq(salesOrderLines.orderId, orderId));
  const movements = buildOrderReserveMovements({
    lines: lines.map((l) => ({ productId: l.productId, warehouseId: l.warehouseId, qty: l.qty })),
  });
  await postDocument(db, { docType: "sales_order", docId: order.id, date: order.date }, movements);
}

export async function cancelOrder(db: Db, orderId: string): Promise<void> {
  await unpostDocument(db, "sales_order", orderId);
  await db.update(salesOrders).set({ status: "cancelled" }).where(eq(salesOrders.id, orderId));
}
